import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import StudioPage from "./pages/StudioPage";
import HomePage from "./pages/HomePage";
import GamePage from "./pages/GamePage";
import ResultsPage from "./pages/ResultsPage";
import HistoryPage from "./pages/HistoryPage";
import GKHomePage from "./pages/GKHomePage";
import GKPlayPage from "./pages/GKPlayPage";
import GKResultsPage from "./pages/GKResultsPage";
import WhoAmIHomePage from "./pages/WhoAmIHomePage";
import WhoAmIPlayPage from "./pages/WhoAmIPlayPage";
import WhoAmIResultsPage from "./pages/WhoAmIResultsPage";
import AirlineHomePage from "./pages/AirlineHomePage";
import AirlinePlayPage from "./pages/AirlinePlayPage";
import AirlineResultsPage from "./pages/AirlineResultsPage";
import ShapesHomePage from "./pages/ShapesHomePage";
import ShapesPlayPage from "./pages/ShapesPlayPage";
import ShapesResultsPage from "./pages/ShapesResultsPage";
import CountryHomePage from "./pages/CountryHomePage";
import CountryPlayPage from "./pages/CountryPlayPage";
import CountryResultsPage from "./pages/CountryResultsPage";
import AirCombatHomePage from "./pages/AirCombatHomePage";
import AirCombatPlayPage from "./pages/AirCombatPlayPage";
import AirCombatResultsPage from "./pages/AirCombatResultsPage";
import GodsHomePage from "./pages/GodsHomePage";
import GodsPlayPage from "./pages/GodsPlayPage";
import GodsResultsPage from "./pages/GodsResultsPage";
import MonumentHomePage from "./pages/MonumentHomePage";
import MonumentPlayPage from "./pages/MonumentPlayPage";
import MonumentResultsPage from "./pages/MonumentResultsPage";

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StudioPage />} />
          <Route path="/jungle-math" element={<HomePage />} />
          <Route path="/game" element={<GamePage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/gk-quiz" element={<GKHomePage />} />
          <Route path="/gk-quiz/play" element={<GKPlayPage />} />
          <Route path="/gk-quiz/results" element={<GKResultsPage />} />
          <Route path="/who-am-i" element={<WhoAmIHomePage />} />
          <Route path="/who-am-i/play" element={<WhoAmIPlayPage />} />
          <Route path="/who-am-i/results" element={<WhoAmIResultsPage />} />
          <Route path="/airline-quiz" element={<AirlineHomePage />} />
          <Route path="/airline-quiz/play" element={<AirlinePlayPage />} />
          <Route path="/airline-quiz/results" element={<AirlineResultsPage />} />
          <Route path="/shapes" element={<ShapesHomePage />} />
          <Route path="/shapes/play" element={<ShapesPlayPage />} />
          <Route path="/shapes/results" element={<ShapesResultsPage />} />
          <Route path="/country-quiz" element={<CountryHomePage />} />
          <Route path="/country-quiz/play" element={<CountryPlayPage />} />
          <Route path="/country-quiz/results" element={<CountryResultsPage />} />
          <Route path="/air-combat" element={<AirCombatHomePage />} />
          <Route path="/air-combat/play" element={<AirCombatPlayPage />} />
          <Route path="/air-combat/results" element={<AirCombatResultsPage />} />
          <Route path="/gods" element={<GodsHomePage />} />
          <Route path="/gods/play" element={<GodsPlayPage />} />
          <Route path="/gods/results" element={<GodsResultsPage />} />
          <Route path="/monument" element={<MonumentHomePage />} />
          <Route path="/monument/play" element={<MonumentPlayPage />} />
          <Route path="/monument/results" element={<MonumentResultsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
